export const siteData = {
  name: "The First Dance",
  tagline: "BY BOGI",
  heroTitle: "THE",
  heroMainTitle: "First Dance",
  heroSubtitle: "MERT A NAGY PILLANAT TÖKÉLETESSÉGET ÉRDEMEL.",
  heroDescription: "Hogy arra tudj figyelni, ami igazán számít: megélni a pillanatot és ragyogni benne.",
  heroImage: "https://customer-assets.emergentagent.com/job_clone-portal-11/artifacts/7wxagztl_DCF54563-C066-464D-B447-F33F65FA1926.jpeg",
  buttons: {
    booking: "IDŐPONTFOGLALÁS",
    services: "SZOLGÁLTATÁSOK"
  }
};

export const servicesSection = {
  subtitle: "Amiben segíthetek",
  title: "Szolgáltatások",
  description: "Teljes körű felkészítés, hogy magabiztosnak és gyönyörűnek érezd magad a nagy napon."
};

export const services = [
  {
    id: 1,
    icon: "heart",
    title: "Esküvői Tánc Oktatás",
    description: "Készülj fel az első táncotokra! Klasszikus keringőtől a modern koreográfiáig, személyre szabott oktatás.",
    image: "https://customer-assets.emergentagent.com/job_clone-portal-11/artifacts/com6vks8_IMG_1704.jpeg"
  },
  {
    id: 2,
    icon: "footprints",
    title: "Catwalk",
    description: "Hogy minden lépésed magabiztosságot sugározzon. Testtartás, egyensúly és elegáns mozgás magassarkúban.",
    image: "https://customer-assets.emergentagent.com/job_clone-portal-11/artifacts/bqtzb07m_IMG_9432.jpeg"
  },
  {
    id: 3,
    icon: "camera",
    title: "Esküvői Fotózás",
    description: "Megörökítem a nagy napotok legszebb pillanatait. Természetes, romantikus képek az emlékekért.",
    image: "https://customer-assets.emergentagent.com/job_clone-portal-11/artifacts/haevpire_IMG_9431.jpeg"
  }
];

export const supportSection = {
  icon: "sparkles",
  title: "Teljes Körű Esküvői Támogatás",
  description: "Szükséged van segítő kézre az esküvőd napján? A menyasszonyi készülődéstől a ceremónia koordinálásáig melletted vagyok, hogy minden zökkenőmentesen menjen.",
  buttonText: "ÉRDEKLŐDÖM"
};

export const gallerySection = {
  subtitle: "Pillanatok",
  title: "Galéria",
  images: [
    {
      id: 1,
      src: "https://images.unsplash.com/photo-1519741497674-611481863552?w=800&q=80",
      alt: "Menyasszony hátulról"
    },
    {
      id: 2,
      src: "https://images.unsplash.com/photo-1511285560929-80b456fea0bc?w=800&q=80",
      alt: "Esküvői tánc"
    },
    {
      id: 3,
      src: "https://images.unsplash.com/photo-1583939003579-730e3918a45a?w=800&q=80",
      alt: "Menyasszony mezőn"
    }
  ]
};

export const testimonialsSection = {
  subtitle: "Rólam mondták",
  title: "Vélemények"
};

export const testimonials = [
  {
    id: 1,
    text: "Az első táncunk varázslatos volt! Bogi türelmes és profi oktatásának köszönhetően magabiztosak voltunk és csodásan néztünk ki a nagy napon.",
    author: "Emma és Tamás",
    service: "Esküvői Tánc",
    rating: 5
  },
  {
    id: 2,
    text: "Rettegtem a magassarkútól, de néhány óra után már magabiztosan sétáltam le az oltárhoz. Életmentő volt ez a felkészítés!",
    author: "Zsófi",
    service: "Magassarkú Oktatás",
    rating: 5
  },
  {
    id: 3,
    text: "Bogi csodálatos fotókat készített rólunk. Mindenki azt kérdezi, hogyan lettünk ennyire természetesek a képeken!",
    author: "Réka és Dávid",
    service: "Esküvői Fotózás",
    rating: 5
  }
];

export const bookingSection = {
  title: "Időpontfoglalás",
  description: "Töltsd ki az alábbi űrlapot és hamarosan jelentkezem az egyeztetés részleteivel.",
  fields: {
    name: "Neved *",
    email: "E-mail cím *",
    phone: "Telefonszám *",
    service: "Szolgáltatás kiválasztása *",
    message: "Mesélj az esküvőd terveiről..."
  },
  buttonText: "KÜLDÉS"
};

export const contactInfo = {
  email: "toth.bogi1999@gmail.com",
  phone: "+36 20 310 7210",
  instagram: "@thefirstdance_bogi"
};
